import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-help-import-providers',
  templateUrl: './help-import-providers.component.html',
  styleUrls: ['./help-import-providers.component.scss']
})
export class HelpImportProvidersComponent
{
  @Input() public language: string;

  public sampleFileUrl = 'assets/files/providers.csv';
  public document360Url = 'https://channels360.document360.io/docs/providers-import';
}
